import {post} from './RequestUtil'

export const WaterMarkerRequestUtil = {
  queryList (params, callback) {
    post('/parse/list', params).then((response) => {
      callback && callback(response)
    })
  }
}



// WEBPACK FOOTER //
// ./src/utils/WaterMarkerRequestUtil.js